export default "__VITE_ASSET__15ae1085__"